import styled from 'styled-components';

import {
  Wrapper
} from 'components/ActionLine/styles'
import {
  Card
} from 'components/GameCard/styles'

export const Section = styled.section`

`;
export const Header = styled.header`

  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5.8rem;

`;
export const Icons = styled.div`

  display: flex;
  justify-content: center;
  align-items: center;
  gap: .8rem;

`;
export const Title = styled.h1`

  ${(props) => props.theme.fonts.interSemibold24};
  font-size: 2.4rem;
  color: ${(props) => props.theme.colors.white100};
  margin-top: .2rem;

`;
export const Content = styled.div`

  margin: 3.2rem 3.2rem 0 3.2rem;

  ${(Wrapper)} {
    margin-top: 1.2rem;
  }

`;
export const GameCardsList = styled.div`

  display: grid;
  grid-template-columns: repeat(auto-fit,minmax(31.7rem,1fr));
  grid-gap: 1.2rem;
  justify-content: center;

  ${(Card)} {
    height: 31rem;
  };

`;